/**
 * Every translation namespace = one JSON file per locale under
 * `public/locales/<locale>/<namespace>.json`.
 *
 * A namespace MUST be listed here or i18next never requests the file and every
 * `t()` call against it silently renders the raw key. (`nfc-forms` shipped
 * unregistered for exactly this reason.)
 *
 * Convention — one namespace per module, named after its route segment, with
 * keys grouped `shared` / `company` / `my_space` inside. Cross-cutting chrome
 * (buttons, nav, validation, toasts) lives in `common`.
 */
export const NAMESPACES = [
  "common",
  "nav",
  "auth",
  "validation",
  "my-space",
  "company",
  "events",
  "nfc-forms",
  "recruitment",
  "studio",
  "esignature",
  "nfc",
  "onboarding",
  "teams",
  "announcements",
  "help-and-support",
  "offboarding",
  "files",
  "ai-assistant",
  "tasks",
  "projects",
  "documents",
  "assets",
  "audit-logs",
  "biometric-devices",
  "chat",
  "guides",
] as const;

export type Namespace = (typeof NAMESPACES)[number];

export const DEFAULT_NAMESPACE: Namespace = "common";
